const CAP23 = {
  id: 23,
  slug: "cap23-criptografia-clave-publica-ii",
  title: "Conceptos básicos de la criptografía de clave pública (II)",
  sections: [
    {
      heading: "Funciones Hash",
      text: [
        "Las funciones hash son algoritmos criptográficos que toman un conjunto de datos de cualquier tamaño y generan un valor de longitud fija, conocido como hash.",
        "Este valor es único para cada entrada: incluso un mínimo cambio en los datos (una letra, un número o un espacio) generará un hash completamente diferente.",
        "En la tecnología blockchain, los hashes se utilizan para vincular los bloques entre sí, asegurando la integridad de los datos y evitando la manipulación.",
        "La función hash más común en blockchain es SHA-256, usada en el proceso de minería, validación de transacciones y generación de direcciones."
      ],
      list: [
        "SHA-256 significa Secure Hash Algorithm con salida de 256 bits.",
        "Cada bloque contiene el hash del bloque anterior, formando la cadena.",
        "El hash funciona como una 'huella digital' del contenido del bloque."
      ]
    },
    {
      heading: "Conceptos básicos de la criptografía asimétrica",
      text: [
        "La criptografía asimétrica es un sistema que utiliza dos claves diferentes pero matemáticamente relacionadas: una clave pública y una clave privada.",
        "Este sistema es la base de la seguridad en blockchain, ya que permite cifrar, firmar y verificar transacciones digitales sin revelar información sensible."
      ]
    },
    {
      heading: "Conceptos esenciales de la criptografía",
      subsections: [
        {
          heading: "Clave criptográfica",
          text: [
            "Una clave criptográfica es una secuencia de caracteres utilizada para cifrar y proteger información.",
            "Funciona como una 'llave digital' que permite bloquear o desbloquear datos, asegurando que solo quien tenga la clave correcta pueda acceder a la información."
          ]
        },
        {
          heading: "Clave pública",
          text: [
            "La clave pública se utiliza para cifrar información que solo puede ser descifrada por su clave privada correspondiente.",
            "En blockchain, también se utiliza para generar direcciones de criptomonedas, lo que permite a otros usuarios enviarte fondos sin revelar tu clave privada."
          ]
        },
        {
          heading: "Clave privada",
          text: [
            "La clave privada es un elemento crítico que siempre debe mantenerse en secreto.",
            "En blockchain, permite acceder a los fondos y firmar transacciones, demostrando que el propietario es el verdadero dueño de los activos.",
            "Quien controla la clave privada, controla los fondos."
          ]
        },
        {
          heading: "Firmas digitales",
          text: [
            "Las firmas digitales permiten verificar la autenticidad e integridad de la información.",
            "Son una prueba de que el mensaje fue creado por el dueño de la clave privada y que no ha sido alterado.",
            "En blockchain, se usan para asegurar que solo el propietario de una billetera pueda autorizar una transacción."
          ]
        },
        {
          heading: "Algoritmos de cifrado",
          text: [
            "Los algoritmos de cifrado son operaciones matemáticas que transforman datos legibles en datos ilegibles para protegerlos.",
            "Existen dos tipos principales:",
          ],
          list: [
            "🔹 Cifrado simétrico (usa una sola clave para cifrar y descifrar). Ejemplo: AES.",
            "🔹 Cifrado asimétrico (usa clave pública y privada). Ejemplo: RSA."
          ]
        }
      ]
    },
    {
      heading: "Importancia de la criptografía en blockchain",
      text: [
        "Todos los conceptos anteriores son esenciales para el funcionamiento de la tecnología blockchain.",
        "Gracias a la criptografía podemos proteger datos, verificar identidades y garantizar transacciones seguras sin intermediarios.",
        "La criptografía es el núcleo de la confianza digital y la base de la seguridad en blockchain."
      ],
      list: [
        "🔹 Permite proteger la información de accesos no autorizados.",
        "🔹 Valida la autenticidad de usuarios y transacciones.",
        "🔹 Evita falsificaciones, fraudes o suplantaciones.",
        "🔹 Hace posible la descentralización al no depender de una autoridad central."
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "La criptografía es la piedra angular de blockchain. Comprender sus principios básicos, como claves, firmas digitales, hashes y cifrado, es fundamental para entender cómo se garantiza la seguridad y confianza en este entorno.",
        "En la próxima lección profundizaremos en cómo estos mecanismos se aplican a las direcciones, billeteras y transacciones en la vida real."
      ]
    }
  ]
};

export default CAP23;
